var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-wide',[_c('div',[_c('sub-navbar',{attrs:{"page":"Customer"}})],1),(_vm.showSearchBox)?_c('div',[_c('SearchCustomerForCustomerPayments')],1):_vm._e(),(_vm.showPaymentsTable)?_c('div',[_c('ShowCustomerPayments')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }